export class TreeStructureData{
    title:String;
    key:String;
    physicalQuantity:number;
    issuedQuantity:number;
    children:TreeStructureData[];
}